import React, { useRef } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { CircularProgress, ClickAwayListener } from '@mui/material';
import colors from '../../../../../../scss/colors';
import boxScrollBarStyle from '../../../../../../scss/js/scrollbars';
import { useWindowSize } from '../../../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../../../utils/constants';
import MainButton from '../../../../buttons/MainButton';
import BaseSwipeableDrawer from '../../../../BaseSwipeableDrawer/BaseSwipeableDrawer';
import classes from './BasicFilterDropdown.module.scss';

export default function BasicFilterDropdown({
  type,
  text,
  mobileWithHeader = true,
  swiperTitle,
  active,
  open,
  setOpen,
  children,
  count,
  pendingCount = false,
  filterCount,
  sxBox,
  sxPopper,
  showHandler = () => {},
  isCountVisible = false,
  extraHeader = { enabled: false, label: '', action: () => {} },
  showFooterButton = false,
  isTextFullWidth = false
}) {
  const size = useWindowSize();
  const ref = useRef(null);
  const { t } = useTranslation();

  function getTextLabelClass() {
    if (active) {
      return isTextFullWidth ? classes.mainInputTextActiveFullWidth : classes.mainInputTextActive;
    }
    return classes.mainInputText;
  }

  return (
    <>
      <div
        ref={ref}
        role="presentation"
        className={`${count > 1 ? classes.mainInputMulti : classes.mainInput} ${active ? classes.active : ''} ${
          open ? classes.openState : ''
        }`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span alt={text} className={getTextLabelClass()}>
          {text}
        </span>
        {count && <span className={classes.count}>{count}</span>}
        <KeyboardArrowDownIcon
          sx={{ width: '22px', height: '22px', color: active ? colors.WHITE_TXT : colors.DARKEST_GREY }}
        />
      </div>
      {open && size.width <= responsiveSizeTimesheet && (
        <BaseSwipeableDrawer closeHandler={() => setOpen(false)}>
          <div className={classes.swiper} />
          {extraHeader.enabled && (
            <span className={classes.extraHeader} role="presentation" onClick={extraHeader.action}>
              {extraHeader.label}
            </span>
          )}
          {mobileWithHeader && (
            <>
              <p className={classes.typeOfFilter}>{swiperTitle}</p>
              <div className={classes.divider} />
            </>
          )}
          {children}
          {showFooterButton && (
            <MainButton
              size="small"
              variant="primary"
              rounded
              forceWidth="90%"
              action={() => {
                showHandler();
                setOpen(false);
              }}
            >
              {pendingCount ? (
                <CircularProgress sx={{ color: colors.WHITE }} size="20px" />
              ) : (
                `Show ${isCountVisible ? filterCount || 0 : ''} results`
              )}
            </MainButton>
          )}
        </BaseSwipeableDrawer>
      )}
      {open && size.width > responsiveSizeTimesheet && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Popper sx={{ ...sxPopper }} open anchorEl={ref.current}>
            <Box
              sx={{
                padding: '30px 0',
                backgroundColor: colors.PAGE_BACKGROUND,
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                borderRadius: '20px',
                ...sxBox,
                ...boxScrollBarStyle
              }}
            >
              {children}
            </Box>
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
}
